import React from 'react'
import herobg from '../../../assets/subservice/OxbrytaHero.png'
import MobileHeroBg from  '../../../assets/subservice/OxbrytaHeroMobile.png'

const HomeOne = () => {
  return (
    <>
      {/* Desktop/Laptop/Tablet Hero Section */}
      <section className="hidden sm:flex relative w-full  md:h-[55vh] lg:h-[85vh] items-center justify-center overflow-hidden bg-[#0100AF]">

        {/* Background Image */}
        {/* <img
          src={herobg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-relative object-cover z-0"
        /> */}

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0  z-10" />

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-6 md:px-16 lg:px-24 py-8 text-center">
          <h1
            className="text-2xl md:text-3xl lg:text-5xl font-bold text-white mb-4 drop-shadow-lg"
            style={{ fontFamily: 'Quicksand, sans-serif' }}
          >
            Had Hernia Mesh Surgery And Suffered <br/>Complications Or Pain?
          </h1>
          <h2
            className="text-sm sm:text-base md:text-xs lg:text-xl text-white mb-6 font-medium drop-shadow leading-relaxed"
            style={{ fontFamily: 'Quicksand, sans-serif' }}
          >
            Defective hernia mesh implants have been linked to infections, organ damage, <br/> and repeat surgeries. You may qualify for compensation. Get a free legal <br/> case review now.
          </h2>
        </div>
      </section>

      {/* Mobile Hero Section */}
      <section className="flex sm:hidden relative w-full min-h-[90vh] items-center justify-center overflow-hidden bg-[#0100AF]">

        {/* Content */}
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-5 text-center">

          <h1
            className="text-white capitalize text-[24px] min-[400px]:text-[26px] min-[500px]:text-[28px] leading-[32px] font-[Quicksand] font-bold -mt-[80px]"
          >
            Had Hernia Mesh<br/> Surgery And Suffered<br/> Complications Or Pain?
          </h1>

          <h2
            className="text-[14px] min-[400px]:text-[15px] min-[500px]:text-[16px] text-white mt-3 font-normal leading-relaxed max-w-[340px]"
            style={{ fontFamily: "Quicksand, sans-serif" }}
          >
            Defective hernia mesh implants have been<br/> linked to infections, organ damage, and<br/> repeat surgeries. You may qualify for<br/> compensation. Get a free legal case review<br/> now.
          </h2>

        </div>

        {/* Overlay */}
        <div className="absolute inset-0 z-10" />

      </section>
    </>
  )
}

export default HomeOne